module.exports = __webpack_public_path__ + "img/ma.821b3239.svg";